import React from 'react';

/**
 * Rows-per-page choices, shared by every paginated reconciliation table — the GST buckets and
 * the four vendor tabs. All six endpoints take the same `pageSize`: omitted = 50, 1–5000 = that
 * many, and the literal 'all' bypasses the cap. One list here so the four tables cannot drift
 * apart from the two.
 *
 * 'all' is deliberately always offered. An earlier version hid it above 500 rows to avoid a
 * large DOM; that call belongs to the person reading the screen, not to us.
 */
export const PAGE_SIZES: Array<{ value: number | 'all'; label: string }> = [
	{ value: 50, label: '50 / page' },
	{ value: 100, label: '100 / page' },
	{ value: 250, label: '250 / page' },
	{ value: 500, label: '500 / page' },
	{ value: 'all', label: 'All rows' },
];

export const PageSizeSelect: React.FC<{
	value: number | 'all';
	onChange: (v: number | 'all') => void;
}> = ({ value, onChange }) => (
	<select
		value={String(value)}
		onChange={e => onChange(e.target.value === 'all' ? 'all' : Number(e.target.value))}
		title='How many rows to show at once. "All rows" fetches the entire filtered set in one request.'
		className='rounded border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500'>
		{PAGE_SIZES.map(o => (
			<option key={String(o.value)} value={String(o.value)}>
				{o.label}
			</option>
		))}
	</select>
);
